export default __webpack_public_path__ + "static/media/CeAssets.e2515325.png";